
import { defineComponent, onMounted, ref } from "vue";
import { store } from "@/store";
import { ActionTypes } from "@/store/actions";

export default defineComponent({
  name: "PrintOptions",
  emits: ["setPrintOptionsPosition", "saveAndContinue"],
  setup(_, { emit }) {
    const dropDown = ref<HTMLDivElement>();

    onMounted(() => {
      if (dropDown.value) {
        emit("setPrintOptionsPosition", dropDown.value);
      }
    });

    const openPrintPreview = () => {
      store.dispatch(ActionTypes.SET_MODAL, "printPreview");
    };

    const saveAndContinue = () => {
      emit("saveAndContinue");
    };

    return { dropDown, openPrintPreview, saveAndContinue };
  },
});
